import formatTime from "../../helpers/formatTime";

import styles from "./timeDisplay.module.scss";

interface TimeDisplayI {
  currentTime: number;
  duration: number;
};

const TimeDisplay = ({ currentTime, duration }: TimeDisplayI) => (
  <div className={styles.timeDisplay}>
    {formatTime(currentTime)} / {formatTime(duration)}
  </div>
);

export default TimeDisplay;
